import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import {
  NOTICE_ISSUER_IMPORT_ROUTE,
  canAccessExecutionRoute,
  canAccessNoticeIssuerImportRoute,
  getPaymentAccessMode,
} from '../utils/payment-access.util';

@Injectable({ providedIn: 'root' })
export class ExecutionGuard implements CanActivate {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  canActivate(_route: unknown, state: RouterStateSnapshot): boolean | UrlTree {
    try {
      const groups = this.authService.currentUser()?.group;
      const targetUrl = state?.url ?? this.router.url ?? '';

      if (canAccessExecutionRoute(groups, targetUrl)) {
        return true;
      }

      if (getPaymentAccessMode(groups) === 'notice-only' && canAccessNoticeIssuerImportRoute(groups)) {
        return this.router.createUrlTree([NOTICE_ISSUER_IMPORT_ROUTE]);
      }

      return this.router.createUrlTree(['/pages-dashboard']);
    } catch {
      return this.router.createUrlTree(['/pages-dashboard']);
    }
  }
}
